import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		token: null,
		path: '/pages/index/index',
		people: {
			id: null,
			name: null,
			tag: null
		},
		taskType:'',
	},
	mutations: {
		savePath (state, path) {
			state.path = path;
		},
		saveToken (state, token) {
			state.token = token
		},
		savePeople (state, people){
			state.people = people
		},
		saveTaskType (state, taskType){
			state.taskType = taskType
		},
	},
	actions: {},
})
export default store
